import { HierarchyLevels } from '@retail/products/types';
import { AppTFunction } from '@retail/app/i18n';
import { PackageType } from '@retail/calculus/types';

interface Props {
  t: AppTFunction;
  bindingType?: HierarchyLevels;
  abbreviation?: boolean;
  packageType?: PackageType;
}

export const getHierarchyLevelLabel = ({ bindingType, abbreviation, packageType, t }: Props) => {
  switch (bindingType) {
    case 'ASSORTMENT':
      return abbreviation
        ? t('myAssortment.levels.assortmentShort')
        : t('myAssortment.levels.assortment');
    case 'MG_PARTICIPANT_ACCOUNT':
      return abbreviation
        ? t('myAssortment.levels.supplierShort')
        : t('myAssortment.levels.supplier');
    case 'OVERGRUPPE':
      return abbreviation
        ? t('myAssortment.levels.overGroupShort')
        : t('myAssortment.levels.overGroup');
    case 'HOVEDGRUPPE':
      return abbreviation
        ? t('myAssortment.levels.mainGroupShort')
        : t('myAssortment.levels.mainGroup');
    case 'VAREGRUPPE':
      return abbreviation
        ? t('myAssortment.levels.productGroupShort')
        : t('myAssortment.levels.productGroup');
    case 'DISCOUNT_GROUP':
      return abbreviation
        ? t('myAssortment.levels.discountGroupShort')
        : t('myAssortment.levels.discountGroup');
    case 'MG_SUPPLIER_ITEM':
      switch (packageType) {
        case 'SECONDARY':
          return abbreviation
            ? t('myAssortment.levels.secondaryShort')
            : t('myAssortment.levels.secondary');
        case 'TERTIARY':
          return abbreviation
            ? t('myAssortment.levels.tertiaryShort')
            : t('myAssortment.levels.tertiary');
        default:
          return abbreviation ? t('myAssortment.levels.itemShort') : t('myAssortment.levels.item');
      }
    default:
      return '';
  }
};
